module.exports = __webpack_public_path__ + "img/20210830_220041.c9e92445.jpg";